/* Aphrodisiac: one product homepage. Swipeable photos, quantity, the phone buy bar and the
   extra Add to cart buttons. The buy box form itself is sent by aph-isolde.js. */
(function () {
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function money(cents, currency) {
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency || 'USD',
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(whole ? 0 : 2);
    }
  }

  function initBuy(el) {
    if (el.getAttribute('data-aph-ready')) return;
    el.setAttribute('data-aph-ready', '1');

    var stage = el.querySelector('[data-aph-stage]');
    var slides = el.querySelectorAll('[data-aph-slide]');
    var thumbs = el.querySelectorAll('[data-aph-thumb]');
    var prev = el.querySelector('[data-aph-prev]');
    var next = el.querySelector('[data-aph-next]');
    var count = el.querySelector('[data-aph-count]');
    var current = 0;

    function width() { return stage ? Math.max(1, stage.clientWidth) : 1; }
    function index() { return stage ? Math.round(stage.scrollLeft / width()) : 0; }

    function keepInStrip(t) {
      var strip = t && t.parentElement;
      if (!strip || strip.scrollWidth <= strip.clientWidth) return;
      var left = t.offsetLeft - strip.offsetLeft;
      if (left < strip.scrollLeft) strip.scrollLeft = left;
      else if (left + t.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + t.offsetWidth - strip.clientWidth;
    }

    function mark(i) {
      current = i;
      each(slides, function (s, k) { s.classList.toggle('is-active', k === i); });
      each(thumbs, function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) keepInStrip(t);
      });
      if (count) count.textContent = String(i + 1);
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }

    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (stage) {
        var left = i * width();
        if (smooth && 'scrollBehavior' in document.documentElement.style) stage.scrollTo({ left: left, behavior: 'smooth' });
        else stage.scrollLeft = left;
      }
      mark(i);
    }

    if (stage) {
      var settle = null;
      stage.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var i = Math.max(0, Math.min(slides.length - 1, index()));
          if (i !== current) mark(i);
        }, 80);
      }, { passive: true });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1, true); }
      });
    }
    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });
    each(thumbs, function (t, k) { t.addEventListener('click', function () { go(k, true); }); });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { go(current, false); }, 120);
    });

    /* Quantity: the button shows the total */
    var qty = el.querySelector('[data-aph-qty]');
    var add = el.querySelector('[data-aph-add]');
    var cents = parseInt(el.getAttribute('data-cents') || '0', 10);
    var currency = el.getAttribute('data-currency');
    var addText = el.getAttribute('data-add-text') || 'Add to cart';
    function refresh() {
      if (!qty || !add || add.disabled || !cents) return;
      var n = Math.min(99, Math.max(1, parseInt(qty.value || '1', 10) || 1));
      add.textContent = addText + ', ' + money(cents * n, currency);
    }
    each(el.querySelectorAll('[data-aph-step]'), function (b) {
      b.addEventListener('click', function () {
        if (!qty) return;
        var v = parseInt(qty.value || '1', 10) || 1;
        qty.value = Math.min(99, Math.max(1, v + parseInt(b.getAttribute('data-aph-step'), 10)));
        refresh();
      });
    });
    if (qty) {
      qty.addEventListener('input', refresh);
      qty.addEventListener('change', function () {
        qty.value = Math.min(99, Math.max(1, parseInt(qty.value || '1', 10) || 1));
        refresh();
      });
    }
    mark(0);
  }

  /* The phone bar appears whenever no other buy button is on screen */
  function initBar() {
    var bar = document.querySelector('[data-aph-solo-bar]');
    if (!bar || bar.getAttribute('data-aph-ready')) return;
    bar.setAttribute('data-aph-ready', '1');
    document.body.classList.add('aph-has-bar');
    var ticking = false;
    function check() {
      ticking = false;
      var h = window.innerHeight || document.documentElement.clientHeight;
      var onScreen = false;
      each(document.querySelectorAll('[data-aph-cta]'), function (c) {
        if (onScreen || !c.offsetParent) return;
        var r = c.getBoundingClientRect();
        if (r.bottom > 0 && r.top < h - 8) onScreen = true;
      });
      bar.classList.toggle('is-visible', !onScreen);
    }
    function queue() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
    check();
  }

  /* The other Add to cart buttons on the page (welcome, notes, bottle, closing).
     Same steps as the buy box in aph-isolde.js: add without leaving the page, then tell the
     theme and the cart app so the cart opens and the count updates. */
  function cartAddUrl() {
    try {
      if (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) return Theme.routes.cart_add_url;
    } catch (e) {}
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function cartSectionIds() {
    var ids = [];
    each(document.querySelectorAll('cart-items-component'), function (c) {
      if (c.dataset && c.dataset.sectionId) ids.push(c.dataset.sectionId);
    });
    return ids;
  }

  function announceCartAdd(target, variantId, quantity, sections) {
    var data = { source: 'product-form-component', itemCount: quantity, sections: sections };
    function plain() {
      target.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: String(variantId || ''), data: data } }));
    }
    try {
      import('@theme/events')
        .then(function (m) { target.dispatchEvent(new m.CartAddEvent({}, String(variantId || ''), data)); })
        .catch(plain);
    } catch (e) {
      plain();
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('.aph-solo-add')) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }
    function restore() { if (btn) { btn.disabled = false; btn.textContent = label; } }

    var body = new FormData(form);
    var sectionIds = cartSectionIds();
    if (sectionIds.length) body.append('sections', sectionIds.join(','));

    fetch(cartAddUrl(), {
      method: 'POST',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          if (btn) btn.textContent = res.description || res.message || 'Could not add to cart';
          setTimeout(restore, 3000);
          return;
        }
        restore();
        announceCartAdd(form, body.get('id'), Number(body.get('quantity')) || 1, res && res.sections);
      })
      .catch(function () {
        restore();
        form.submit();
      });
  }, true);

  function initAll(scope) {
    each((scope || document).querySelectorAll('[data-aph-solo-buy]'), initBuy);
    initBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
